import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'home', component: Home },
    {
      path: '/company',
      name: 'company',
      props: true,
      component () { return System.import('@/pages/Company') }
    },
    {
      path: '/products',
      name: 'products',
      props: true,
      component () { return System.import('@/pages/Products') }
    },
    {
      path: '/product/:proId',
      name: 'product',
      props: true,
      component () { return System.import('@/pages/Product') }
    },
    {
      path: '/special',
      name: 'special',
      props: true,
      component () { return System.import('@/pages/Special') }
    },
    {
      path: '/search/:proName',
      name: 'search',
      props: true,
      component () { return System.import('@/pages/Search') }
    },
    {
      path: '/agency',
      name: 'agency',
      props: true,
      component () { return System.import('@/pages/Agency') }
    },
    {
      path: '/news',
      name: 'news',
      meta: { nav: { name: 'News & Events', to: '/news' } },
      component () { return System.import('@/pages/News/Index') }
    },
    {
      path: '/news/:newsId',
      name: 'news-detail',
      props: true,
      component () { return System.import('@/pages/News/News') }
    },
    {
      path: '/stock',
      name: 'stock',
      props: true,
      component () { return System.import('@/pages/Stock') }
    },
    {
      path: '/contact',
      name: 'contact',
      props: true,
      component () { return System.import('@/pages/Contact') }
    }
  ],
  // mode:'history',
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else {
       Velocity(document.querySelector('body'), 'scroll', {
         duration: 500,
         offset: top
       })
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js